import axios from 'axios'
import Swal from 'sweetalert2'

const baseURL = import.meta.env.VITE_API_BASE_URL || ''

export const apiClient = axios.create({
  baseURL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
})

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token')
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`
  }

  const method = (config.method || 'get').toLowerCase()
  if (['post', 'put', 'patch', 'delete'].includes(method)) {
    const key = `idem_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`
    if (!config.headers['Idempotency-Key']) {
      config.headers['Idempotency-Key'] = key
    }
    if (!config.headers['X-Request-ID']) {
      config.headers['X-Request-ID'] = key
    }
  }

  return config
})

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        console.warn('⚠️ [API] 401 Unauthorized - clearing auth session')
        localStorage.removeItem('admin_token')
        localStorage.removeItem('admin_refresh_token')
        localStorage.removeItem('admin_user')
        if (window.location.pathname !== '/login') {
          window.location.href = '/login?error=session_expired'
        }
      } else if (error.response.status === 403) {
        const msg = error.response.data?.message || error.response.data?.error || 'Access Denied: You do not have the required administrative permissions for this operation.'

        Swal.fire({
          icon: 'error',
          title: 'Access Denied (403)',
          text: msg,
          confirmButtonColor: '#ef4444'
        })
      }
    }
    return Promise.reject(error)
  }
)

export default apiClient
